// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThumbnailGrid_wrapper__UNzkG","item":"ThumbnailGrid_item__mrdCN","image":"ThumbnailGrid_image__3hpvF"};